import styled from 'styled-components';

import { body } from '@constants/fonts';

export const LineItem = styled.div<{ selected: boolean }>`
  padding: 10px 40px 10px 60px;
  background: ${({ selected, theme }) =>
    selected ? theme.palette.info.light : theme.palette.background.paper};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  position: relative;
  transition: background-color 0.2s;
  font-family: ${body};
  cursor: pointer;
  color: ${({ selected, theme }) =>
    selected ? theme.palette.info.main : theme.palette.text.primary};
  min-height: 23px;
  font-size: 16px;
  display: flex;
  align-items: center;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.palette.action.hover};
    box-shadow: ${({ theme }) => theme.shadows[1]};
    z-index: 1;
  }

  &:last-child {
    border-bottom: 0;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 9px;
  left: 25px;
  width: 20px;
  height: 20px;
  font-size: 20px;
  text-align: center;
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
`;
